import { getPageSize } from '../../../utils';
import { PaginationProps } from './types';

export const getPagingInfo = (props: PaginationProps) => {
  const totalCount = props.totalCount || 0;
  const dataSize = (props.data && props.data.length) || 0;
  const hasPagination = totalCount > dataSize;
  const pageSize = props.pageSize || getPageSize();
  const pageCount = Math.ceil(totalCount / pageSize);

  return {
    totalCount,
    dataSize,
    hasPagination,
    pageSize,
    pageCount,
  };
};

export const BUTTON_BREAKPOINTS = [480, 768, 1024];

export const DEFAULT_BUTTON_COUNTS = [0, 1, 2, 3];
